/**
 * Indicadores de fluxo.
 *
 * Regra da tela: TODO numero e clicavel e abre `/tarefas` ja filtrado. Numero
 * que nao da para abrir nao e indicador, e enfeite -- quem ve "14 atrasados"
 * quer ver quais sao os catorze.
 */
export const nav = {
    permissao: 'deck.indicadores:ver',
    section: 'Gestao',
    title: 'Indicadores',
    icon: 'insights',
    route: '/indicadores',
    sequence: 21,
};

export default [
    {
        path: '/indicadores',
        name: 'indicadores',
        component: () => import('./pages/IndicadoresPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.indicadores:ver' },
    },
];
